import { TableColumnInfo, TableRowInfo } from "../main";
import { BaseColumnFormatter } from "./BaseColumnFormatter";
import { BaseURLImageFormatter } from "./BaseURLImageFormatter";

export class URLFormatter extends BaseColumnFormatter
{
    private formatter: BaseURLImageFormatter = new BaseURLImageFormatter();
    constructor(width: string = "250px")
    {
        super();
        this.onclick_overrided = true;
        this.width = width;
    }
    override format(value: any, column: TableColumnInfo, row: TableRowInfo<any>, printable: boolean): any
    {
        return this.formatter.format({
            text: value,
            href: value,
            image: { url: "https://static.namirasoft.com/image/concept/type/url.png", alt: "url" }
        }, column, row, printable);
    }
}